import { Route } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { LayoutComponent } from './layout/layout.component';
import { AdminRoutes } from './routes/admin.routes';
import { CustomerRoutes } from './routes/customer.routes';
import { SiteRoutes } from './routes/site.routes';
import { I18nRoutes } from './routes/i18n.routes';
import { ProductRoutes } from './routes/product.routes';

export const appRoutes: Route[] = [
  {
    path: 'sign-in',
    loadComponent: () => import('./pages/auth/sign-in/sign-in.page'),
  },
  {
    path: 'sign-up',
    loadComponent: () => import('./pages/auth/sign-up/sign-up.page'),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.page'),
      },
      ...AdminRoutes,
      ...ProductRoutes,
      ...CustomerRoutes,
      ...SiteRoutes,
      ...I18nRoutes,
      {
        path: 'my-page',
        loadComponent: () => import('./pages/my-page/my-page.page'),
      },
    ],
  },
];
